import { useRef, useState } from 'react'
import { SDrawerOrModal, SGeneralForms } from 'shj-components'
import { getFlowTranster, getUserIdentityFn } from '@/services/order'
import DebounceSelect from '@/components/DebounceSelect'
import { isNilOrNull } from '@/utils'
import { message } from 'antd'

export default function FlowTransfer(props: any) {
  const { title = '转交办理', open, onClose, taskId } = props
  const formRef = useRef<any>()
  const [loading, setLoading]: any = useState(false)
  const [messageApi, contextHolder] = message.useMessage();

  async function loadPersonList(name: string) {
    if (isNilOrNull(name)) return
    const searchObj = {
      queryEmployee: true,
      queryOrg: true,
      employeeFilter: { status: true, userNameKeyword: name },
    }
    return await getUserIdentityFn(searchObj).then((res: any) => {
      console.log(res)
      const staffData = (res?.list || []).map((item: any) => ({
        label: `${item?.userName} - ${item?.orgName} - ${item?.roleName}`,
        value: item?.ucenterUserId,
        id: item?.ucenterUserId,
      }))
      return staffData
    })
  }

  const config = [
    {
      formItem: [
        {
          label: '流程任务ID',
          name: 'taskId',
          spanCol: 24,
          hidden: true,
        },
        {
          label: '转办用户',
          name: 'targetUserId',
          type: 'tree',
          spanCol: 24,
          required: true,
          children: () => {
            return (
              <DebounceSelect
                style={{ width: '100%' }}
                placeholder={'请输入进行搜索,支持模糊搜索'}
                fetchOptions={loadPersonList}
                getPopupContainer={triggerNode => triggerNode.parentElement}
                listHeight={160}
                allowClear
                onChange={val => {
                  formRef?.current?.onFormRef()?.setFieldsValue({
                    targetUserId: val?.value,
                  })
                }}
                //   getPopupContainer={()=>document.getElementById('root')}
              />
            )
          },
        },
        {
          label: '备注',
          name: 'reason',
          type: 'textarea',
          spanCol: 24,
          comConfig: {
            showCount: true,
            maxLength: 200,
            rows: 6,
            // getPopupContainer:triggerNode => triggerNode.parentElement
          },
        },
      ],
    },
  ]
  const _onSubmit = () => {
    const form = formRef.current?.onFormRef()
    form.validateFields().then((val: any) => {
      if (isNilOrNull(taskId)) {
        messageApi.info('未获取到taskId')
        return
      }
      val.taskId = taskId
      console.log(val)
      setLoading(true)
      //   onSubmit && onSubmit(val)
      getFlowTranster(val).then((res:any)=>{
        // 弹窗关闭了,组件销毁导致message不显示了?
        // messageApi.success(res?.message,6);
        _onClose(res?.message)
      }).catch((err:any)=>{
        messageApi.error(err?.message,3);
      }).finally(()=>{
        setLoading(false)
      })
    })
  }
  const _onClose = (msg?:string) => {
    onClose && onClose(msg)
    formRef.current?.onFormRef()?.resetFields()
  }

  return (
    <SDrawerOrModal
      mode="modal"
      title={title}
      open={open}
      onCancel={()=>_onClose()}
      loading={loading}
      onOk={_onSubmit}
      okText='转交'
    >
     {contextHolder}
      <SGeneralForms ref={formRef} configs={config} />
    </SDrawerOrModal>
  )
}
